// extracted by mini-css-extract-plugin
export default {"btnContainer":"buttonsFooter_btnContainer__qRZNO","btnRigth":"buttonsFooter_btnRigth__8y4gS","btnLeft":"buttonsFooter_btnLeft__DwTEh"};